import I18n from 'i18n-js';
import React from 'react';
import LocationUtil from '../shared/location_util';
import { FOLLOW_PROMPT_PARAM } from '../shared/constants';
import { HeartStraightIcon } from '@reverbdotcom/cadence/icons/react';
import classNames from 'classnames';
import { useFindFavorite } from './find_favorite_context';
import { EntityType, mapFavoriteToEntityType } from '@reverbdotcom/commons/src/favorites/entity_type';
import { RCFavoriteButton, RCFavoriteButtonProps, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { redirectToSignin } from '@reverbdotcom/commons/src/signup_signin_helper';

interface Props {
  renderWithBanner: boolean;
  buttonTypeOverride?: 'link' | 'secondary';
  condensed?: boolean;
  iconButtonSize?: RCFavoriteButtonProps['size'];
  iconButtonVariant?: RCFavoriteButtonProps['variant'];
}

export const LoggedOutFavoriteButton = function (props: Props) {
  const { favorite, canFavorite } = useFindFavorite();
  const entityType = mapFavoriteToEntityType(favorite);

  const handleClick = function (evt) {
    evt.preventDefault();

    if (!canFavorite) {
      return;
    }

    redirectToSignin('FavoriteButton', LocationUtil.currentPageWithParams({ [FOLLOW_PROMPT_PARAM]: true }));
  };

  const buttonType = props.buttonTypeOverride || (entityType === EntityType.Product || props.renderWithBanner ? 'secondary' : 'link');
  const classes = classNames(
    'favorite-button__button',
    {
      'favorite-button__button--link': buttonType === 'link',
      'favorite-button__button--secondary': buttonType === 'secondary',
      'favorite-button__button--disabled': !canFavorite,
    },
  );

  return (props.condensed ?
    <RCFavoriteButton
      favorited={favorite.favorited}
      onClick={handleClick}
      size={props.iconButtonSize}
      variant={props.iconButtonVariant}
    />
    :
    <div className="favorite-button">
      <button
        type="button"
        className={classes}
        onClick={handleClick}
        data-disabled={!canFavorite || null}
      >
        <RCTextWithIcon
          svgComponent={HeartStraightIcon}
          placement="left"
        >
          {I18n.t(`discovery.favorites.favoriteButton.save.${entityType}`)}
        </RCTextWithIcon>
      </button>
    </div>
  );
};
